<template>
    <div id="paper-root" style="max-width: 1200px;margin: 0 auto;width: 100%;min-height: calc(100vh - 50px);">
        <template v-if="paperQuestion.length > 0">
            <a-layout theme="light" class="paper-style-2" style="min-height: calc(100vh - 50px);">
                <a-layout>
                    <a-layout-content>
                        <!-- 一页一题样式 -->
                        <div class="paper-content" style="margin: 30px auto;" :bordered="false">
                            <div class="paper-content-item" v-show="qi == currentQuestionIndex"
                                v-for="(q, qi) in paperQuestion" :key="qi">
                                <a-row>
                                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <a-card class="stem-card" :bordered="false"
                                            :headStyle="{ 'background': '#c8c8c84a' }"
                                            :bodyStyle="{ 'background': '#c8c8c84a' }">
                                            <span slot="title">
                                                <span>{{ getQuestionTypeText(q.questionType) }}</span>
                                            </span>
                                            <div class="question-stem">
                                                <p style="float: left;">{{ qi + 1 }}、</p>
                                                <div style="float: left;" v-html="q.questionStem"
                                                    :id="'question-stem-' + q.id">
                                                </div>
                                            </div>
                                        </a-card>
                                    </a-col>
                                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <a-card class="answer-card" title="" :bordered="false"
                                            :headStyle="{ 'background': '#c8c8c84a' }"
                                            :bodyStyle="{ 'background': '#c8c8c84a' }" v-if="paperAnswer.length > 0">
                                            <!-- 单选 -->
                                            <template v-if="q.questionType == 1">
                                            <div class="radioBox" v-for="(o, oi) in q.questionOptions" :key="oi">
                                                <div class="radio-content">
                                                    <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == oi && q.gotScore > 0">
                                                        <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                    </div>
                                                    <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == oi && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                    <div class="radioList question-letter" v-else>{{index2letter(oi)  }}</div>
                                                    <div class="question-options-content">
                                                        <div class="option" v-html="o.item"></div>
                                                    </div>
                                                </div>
                                            </div> 
                                            </template>
                                            <!-- 多选 -->
                                            <a-checkbox-group class="question-checkbox" v-if="q.questionType == 2"
                                                v-model="paperAnswer[qi]['myAnswer']">
                                                <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi"
                                                    disabled>
                                                    <div class="checkbox-content">
                                                        <span class="question-letter">{{ index2letter(oi) }}
                                                        </span>
                                                        <div class="question-options-content">
                                                            <div class="option" v-html="o.item"></div>
                                                        </div>
                                                    </div>
                                                </a-checkbox>
                                            </a-checkbox-group>
                                            <!-- 判断题 -->
                                            <template v-if="q.questionType == 3">
                                                <div class="radioBox" >
                                                    <div class="radio-content">
                                                        <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == 'true' && q.gotScore > 0">
                                                            <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                        </div>
                                                        <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == 'true' && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                        <div class="radioList question-letter" v-else>{{index2letter(0)  }}</div>
                                                        <div class="question-options-content">
                                                            <div class="option" >正确</div>
                                                        </div>
                                                    </div>
                                                </div> 
                                                <div class="radioBox" >
                                                    <div class="radio-content">
                                                        <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == 'false' && q.gotScore > 0">
                                                            <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                        </div>
                                                        <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == 'false' && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                        <div class="radioList question-letter" v-else>{{index2letter(1)  }}</div>
                                                        <div class="question-options-content">
                                                            <div class="option" >错误</div>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </template>    
                                            <!-- 填空题 -->
                                            <div class="question-fill-wrap" v-if="q.questionType == 4">
                                                <a-input class="question-fill" :readOnly="examStatus != 1" disabled
                                                    v-for="oi in q.questionOptions.fillGapNum" :key="oi"
                                                    v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                                                    :addonBefore="'第' + oi + '空'" :placeholder="'请填写第' + oi + '空回答'" />
                                            </div>
                                            <!-- 主观题 阅读分析-->
                                            <div class="question-read"
                                                v-if="q.questionType == 5 || q.questionType == 6">
                                                <a-textarea :readOnly="examStatus != 1" disabled
                                                    :auto-size="{ minRows: 5, maxRows: 20 }"
                                                    :placeholder="$t('exam.answerArex')"
                                                    v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                                            </div>
                                            <p style="padding: 10px 0;font-size: 18px;color: #666;">
                                                正确答案：{{ answer2Text(paperQuestion[qi]) }}</p>
                                            <p v-if="q.questionAnalysis" style="font-size: 18px;">解析：<span v-html="q.questionAnalysis"></span>
                                            </p>
                                            <!-- 控制条 -->
                                            <div class="question-opt-btn">
                                                <div class="switch-btn">
                                                    <a-button class="prevBtn" type="primary" @click="prevQuestion"
                                                        v-show="currentQuestionIndex != 0">上一题</a-button>
                                                    <a-button class="nextBtn" type="primary"
                                                        v-show="currentQuestionIndex != paperQuestion.length - 1"
                                                        @click="nextQuestion">下一题</a-button>
                                                </div>
                                            </div>
                                        </a-card>
                                    </a-col>
                                </a-row>
                            </div>

                        </div>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </template>
        <template v-else>
            <div style="margin-top: 50px;">
                <a-empty description="暂无数据" />
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'

export default {
    name: 'Examine',
    mixins: [mixinDevice, jumpMixins, examMixins],
    components: {
        JModal,
        Voice
    },
    data() {
        return {
            heightOffset: 0,
            paperId: '',
            departId: '',
            paperDeptId: '',
            eventApplyId: '', //报名ID
            eventApplyCategory: '', //报名赛项
            userPaperList: [],
            loadingUserPaperList: false,
            userPaperInfo: {}, //用户答题卡信息
            paperQuestion: [], //已经过转换的题目信息
            questionSections: {},//题目分类信息
            paperAnswer: [], // 答题卡信息
            undoCount: 0, //未作答题目数量
            isCurrentQuestionChange: false, // 当前题目是否已修改
            userPaperId: '', // 答题卡ID
            paperDescVisible: false, //试卷介绍是否可见
            selectPaperVisible: false, //选择试卷modal
            cameraList: [],
            currentCamera: '',
            mediaRecorder: null,
            screenRecorder: null,
            duration: 0, //用时
            remaining: 0, //剩余时间
            remainTimeText: '',
            examStatus: -1, //考试状态 -1预览 0已结束 1正在考试
            canRequestQustion: true, //是否可以请求题目
            canSave: true, //防止保存试卷高频点击
            canSubmit: true, //防止提交试卷高频点击
            isRequestMyPaperQuestion: false, //是否已请求试卷
            isSaved: false, //答题是否已保存
            drawerStatus: false,   //答题卡
            pageNo: 1,
            dataInfo: {}
        }
    },
    watch: {
        paperAnswer: {
            handler(newValue, oldValue) {
                if (this.paperQuestion) {
                    this.isSaved = false
                    this.isCurrentQuestionChange = true
                    let undoCount = 0
                    this.paperQuestion[this.currentQuestionIndex]['isSubmit'] = true
                    for (let i = 0; i < this.paperQuestion.length; i++) {
                        if (!this.isWriteAnswer(i)) { undoCount++ }
                    }
                    this.undoCount = undoCount
                }
            },
            deep: true
        },
        currentQuestionIndex(newValue, oldValue) {
            if (this.isCurrentQuestionChange && this.isWriteAnswer(oldValue)) {
            }
            this.isCurrentQuestionChange = false
        }
    },
    created() {
        let that = this
        // this.getCode()
        this.requestMyPaperQuestionInfo(this.$route.query) //获取试卷列表
        //拦截未登录
        if (!this.$store.getters.userInfo) {
            this.$info({
                title: that.$t('sys.notLogin'),
                content: that.$t('exam.pleaseToLogin'),
                okText: that.$t('sys.toLogin'),
                onOk() {
                    that.toLogin()
                },
            });
            // return
        } else {
            console.log("userInfo", this.$store.getters.userInfo);
        }

    },
    mounted() {
        document.title = this.$route.query.name

    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    //离开页面
    beforeDestroy() {

    },
    methods: {
        upload2Qiniu: upload2Qiniu,
        dataURLtoBlob: dataURLtoBlob,
        //请求答题卡和题目
        requestMyPaperQuestionInfo(paperModal) {
            getAction('/teaching/teachingUserPaper/myWrongQuestion', { pageNo: this.pageNo, pageSize: 4, knowledgePoint: paperModal.id }).then((res) => {
                if (res.success && res.result != null) {
                    this.dataInfo = res.result
                    this.parseQuestion(res.result.records)
                } else {
                    this.$message.error(res.message)
                    this.userPaperId = ''
                    this.changeURLStatic("userPaperId", "")
                }
            })
        },
        nextQuestion() {
            let _this = this
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == this.paperQuestion.length - 1) {
                return
            }
            this.currentQuestionIndex++
            if (this.currentQuestionIndex == (this.paperQuestion.length - 2) && this.pageNo < this.dataInfo.pages) {
                _this.pageNo++
                _this.requestMyPaperQuestionInfo(_this.$route.query)
            }
        },
        prevQuestion() {
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == 0) {
                return
            }
            this.currentQuestionIndex--
        },

        //解析题目
        parseQuestion(question) {
            let that = this
            let currentSection = null;
            let preLoadEditorQuestion = null; // 预加载编辑器的题目
            for (let qi in question) {
                let q = question[qi]
                //解析题目分类
                if (q.questionSection) {
                    currentSection = qi
                    this.questionSections[qi] = {
                        text: q.questionSection,
                        count: 0,
                        score: 0
                    }
                }
                if (currentSection != null) {
                    this.questionSections[currentSection].count += 1;
                    this.questionSections[currentSection].score += q.questionScore;
                }
                if (q.questionOptions != null) {
                    q.questionOptions = JSON.parse(q.questionOptions)
                }
                q.voiceText = this.getQuestionVoice(q)
                this.paperQuestion.push(q)
                if (q.myAnswer != null || q.myAnswerFile != null) {
                    this.paperAnswer.push({ qid: q.questionId, myAnswer: this.parseAnswer(q.questionType, q.myAnswer), myAnswerFile: q.myAnswerFile })
                } else {
                    if (q.questionType == 2 || q.questionType == 4) {
                        //填空题 多选题结构
                        this.paperAnswer.push({ qid: q.questionId, myAnswer: [] })
                    } else {
                        this.paperAnswer.push({ qid: q.questionId, myAnswer: '' })
                    }
                }
                //渲染填空题dom
                if (q.questionType == 4) {
                    this.renderGapFillingStemDom(q, qi)
                }
                if (q.questionType == 7) {
                    preLoadEditorQuestion = q
                }
            }
            this.examStatus = 1
        },
        download(url) {
            window.open(url + "?t=" + new Date().getTime())
        },
    },
}
</script>
<style lang="less" scoped>
@import url('../../assets/exam.less');
</style>